// extracted by mini-css-extract-plugin
module.exports = {"NoBottomBorder":"EditPage_NoBottomBorder__OzND7"};